<div class="app-root" [class.app-root--blocked-on-mobile]="isMobileVersionDisabled$ | async">
  <div class="app-root__page">
    <router-outlet />
  </div>

  <div class="app-root__mobile-stub">
    <itc-mobile-stub />
  </div>

  <itc-ada-chat-button />
</div>
